import { ca } from '@cian/analytics';

import { ITrackOfferActionsProps } from '../types/tracking';

const OFFERS_ON_PAGE = 28;

const trackingReasonToListingType = {
  pin_click: 'map',
  all_objects_on_map: 'list',
};

export function trackCardClick({
  offerPosition,
  offerId,
  offersLength,
  pageNumber,
  reason,
  isCianPartner,
  partnerUrl,
  jsonQuery,
  queryString,
}: ITrackOfferActionsProps) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_card',
    label: 'card_detail_in_newlist',
    referrer: window.location.href,
    page: {
      pageType: 'Listing',
      listingType: trackingReasonToListingType[reason],
      offersQty: offersLength < OFFERS_ON_PAGE ? offersLength : OFFERS_ON_PAGE,
      pageNumber,
      extra: {
        reason,
        mobileWebsiteType: 'new',
      },
      // Когда мкс отображается на ЧПУ ссылке queryString можно получить только из стейта
      queryString: window.location.search || queryString,
    },
    products: [
      {
        id: offerId,
        position: offerPosition,
        offerType: 'offer',
        extra: {
          isPartner: isCianPartner || undefined,
          partner_url: partnerUrl,
        },
      },
    ],
    sc: jsonQuery,
  });
}
